import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Loading, LoadingWrapper } from 'barnyard/components';
import { localStorageHelper } from '~/accounts/core/utils';
import track, { analyticsTypes } from '~/app/vet/core/analytics';
import { Row, Col } from 'barnyard/layouts';
import VendorInfo from '../forms/VendorInfo';
import { FINISHED_URL, USER_FORM_URL } from '../constants';
import Stepper from './Stepper';

const classNamePrefix = 'Signup--FormPage';
const localStorageSaveLocation = '_saved_vendor_form';


class VendorInfoView extends Component {
  constructor(props) {
    super(props);

    _.bindAll(this, 'handleSubmit');

    this.state = {
      vendorForm: localStorageHelper.retreiveJson(localStorageSaveLocation)
    };
  }

  componentDidMount() {
    track(analyticsTypes.SIGNUP_VIEW_VENDOR, _.get(this.props, 'location.query', {}));
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { buyer: prevBuyer } = prevProps;
    const { buyer, location } = this.props;

    // If there's no buyer, force redirect to the start of the signup flow
    if (_.isNull(buyer)) {
      window.location = USER_FORM_URL;
      return;
    }

    if (!buyer.isError && prevBuyer.isUpdating === true && buyer.isUpdating === false) {
      localStorageHelper.clear();
      track(analyticsTypes.SIGNUP_COMPLETE);
      setTimeout(
        () => {
          // Add in a timeout before moving location so
          // that we leave time for the track even to occur
          // before we leave this bundle
          window.location = location.query.next || FINISHED_URL;
        },
        500
      );
    }
  }

  handleSubmit(values) {
    const {
      buyerVendorsUpdateAction
    } = this.props;

    let vendors_used = [];

    if (values.distributors) {
      vendors_used = vendors_used.concat(values.distributors);
    }

    if (values.manufacturers) {
      vendors_used = vendors_used.concat(values.manufacturers);
    }

    if (values.labs) {
      vendors_used = vendors_used.concat(values.labs);
    }

    if (values.compounders) {
      vendors_used = vendors_used.concat(values.compounders);
    }

    if (values.miscellaneous) {
      vendors_used = vendors_used.concat(values.miscellaneous);
    }

    buyerVendorsUpdateAction({ vendors_used, has_completed_signup: true });
  }

  render() {
    const {
      buyerFormFieldFetches,
      buyerFormFields,
      buyer,
    } = this.props;
    const { vendorForm } = this.state;

    return (
      <div className={classNamePrefix}>
        <Stepper current={2} />
        <LoadingWrapper loading={buyer && (buyer.isLoading || buyer.has_completed_signup)}>
          <Row align='middle' justify='center'>
            <Col className={`${classNamePrefix}__title`} span={12}>
              <h2>Tell Us Which Vendors You Use!</h2>
            </Col>
            <Col span={12}>
              {
                !buyerFormFieldFetches.isFetched ? (
                  <Loading center={true} />
                ) : (
                  <VendorInfo
                    initialValues={vendorForm}
                    onChange={values => localStorageHelper.saveJson(localStorageSaveLocation, values)}
                    buyerFormFields={buyerFormFields}
                    enableReinitialize={true}
                    keepDirtyOnReinitialize={true}
                    onSubmit={this.handleSubmit}
                  />
                )
              }
            </Col>
          </Row>
        </LoadingWrapper>
      </div>
    );
  }
}

VendorInfoView.propTypes = {
  buyer: PropTypes.object.isRequired,
  buyerFormFieldFetches: PropTypes.object.isRequired,
  buyerFormFields: PropTypes.object.isRequired,
  buyerVendorsUpdateAction: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired
};

export default VendorInfoView;
